var map = {
	"./discover": 1874,
	"./discover.js": 1874,
	"./home": 3768,
	"./home.js": 3768,
	"./login": 2870,
	"./login.js": 2870,
	"./message": 6290,
	"./message/": 6290,
	"./message/[id]": 4056,
	"./message/[id].js": 4056,
	"./message/index": 6290,
	"./message/index.js": 6290,
	"./post/[id]": 6161,
	"./post/[id].js": 6161,
	"./profile/[id]": 145,
	"./profile/[id].js": 145,
	"./register": 7559,
	"./register.js": 7559
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2150;